import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Authority } from '../authority.model';

export enum AuthorityActionTypes {
  GetAllAuthoritys = '[Authority] Get Authoritys',
  GetAuthoritysFail = '[Authority] Get Authoritys Fails',
  LoadAuthoritys = '[Authority] Load Authoritys',
  AddAuthority = '[Authority] Add Authority',
  UpsertAuthority = '[Authority] Upsert Authority',
  AddAuthoritys = '[Authority] Add Authoritys',
  UpsertAuthoritys = '[Authority] Upsert Authoritys',
  UpdateAuthority = '[Authority] Update Authority',
  UpdateAuthoritys = '[Authority] Update Authoritys',
  DeleteAuthority = '[Authority] Delete Authority',
  DeleteAuthoritys = '[Authority] Delete Authoritys',
  ClearAuthoritys = '[Authority] Clear Authoritys'
}

export class GetAllAuthoritys implements Action {
  readonly type = AuthorityActionTypes.GetAllAuthoritys;
}

export class GetAuthoritysFail implements Action {
  readonly type = AuthorityActionTypes.GetAuthoritysFail;
}

export class LoadAuthoritys implements Action {
  readonly type = AuthorityActionTypes.LoadAuthoritys;

  constructor(public payload: { authoritys: Authority[] }) {}
}

export class AddAuthority implements Action {
  readonly type = AuthorityActionTypes.AddAuthority;

  constructor(public payload: { authority: Authority }) {}
}

export class UpsertAuthority implements Action {
  readonly type = AuthorityActionTypes.UpsertAuthority;

  constructor(public payload: { authority: Authority }) {}
}

export class AddAuthoritys implements Action {
  readonly type = AuthorityActionTypes.AddAuthoritys;

  constructor(public payload: { authoritys: Authority[] }) {}
}

export class UpsertAuthoritys implements Action {
  readonly type = AuthorityActionTypes.UpsertAuthoritys;

  constructor(public payload: { authoritys: Authority[] }) {}
}

export class UpdateAuthority implements Action {
  readonly type = AuthorityActionTypes.UpdateAuthority;

  constructor(public payload: { authority: Update<Authority> }) {}
}

export class UpdateAuthoritys implements Action {
  readonly type = AuthorityActionTypes.UpdateAuthoritys;

  constructor(public payload: { authoritys: Update<Authority>[] }) {}
}

export class DeleteAuthority implements Action {
  readonly type = AuthorityActionTypes.DeleteAuthority;

  constructor(public payload: { id: string }) {}
}

export class DeleteAuthoritys implements Action {
  readonly type = AuthorityActionTypes.DeleteAuthoritys;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearAuthoritys implements Action {
  readonly type = AuthorityActionTypes.ClearAuthoritys;
}

export type AuthorityActions =
 LoadAuthoritys
 | AddAuthority
 | UpsertAuthority
 | AddAuthoritys
 | UpsertAuthoritys
 | UpdateAuthority
 | UpdateAuthoritys
 | DeleteAuthority
 | DeleteAuthoritys
 | ClearAuthoritys
 | GetAllAuthoritys
 | GetAuthoritysFail;
